import { createContext, useContext, useState, useEffect, useCallback, useRef } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);

export function NotificationsProvider({ children }) {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const timer = useRef(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/community/notifications");
      setItems(data.notifications || []);
      setUnread(data.unread || 0);
    } catch {}
  }, []);

  const markAllRead = useCallback(async () => {
    setUnread(0);
    setItems((list) => list.map((n) => ({ ...n, read: true })));
    try { await api.post("/community/notifications/read-all"); } catch {}
  }, []);

  const markRead = useCallback(async (id) => {
    setItems((list) => list.map((n) => (n.notification_id === id ? { ...n, read: true } : n)));
    setUnread((u) => Math.max(0, u - 1));
    try { await api.post(`/community/notifications/${id}/read`); } catch {}
  }, []);

  useEffect(() => {
    refresh();
    timer.current = setInterval(refresh, 45000);
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(timer.current); window.removeEventListener("focus", onFocus); };
  }, [refresh]);

  return <Ctx.Provider value={{ items, unread, refresh, markAllRead, markRead }}>{children}</Ctx.Provider>;
}

export const useNotifications = () =>
  useContext(Ctx) || { items: [], unread: 0, refresh: () => {}, markAllRead: () => {}, markRead: () => {} };
